import { useQueryClient } from "@tanstack/react-query";
import { createContext, use, useEffect, useState, type ReactNode } from "react";

import { createInvalidator } from "./invalidations";
import { openEventStream, type StreamStatus } from "./stream";

const LiveStatus = createContext<StreamStatus>("connecting");

/** Holds the app's one event stream open while it is mounted (inside the auth gate) and turns each event into refetches. */
export function LiveEventsProvider({ children }: { children: ReactNode }) {
    const queryClient = useQueryClient();
    const [status, setStatus] = useState<StreamStatus>("connecting");

    useEffect(() => {
        const invalidator = createInvalidator(queryClient);
        const stop = openEventStream({
            onEvent: invalidator.push,
            onStatus: setStatus,
            onReconnected: () => void queryClient.invalidateQueries(),
        });
        return () => {
            stop();
            invalidator.cancel();
        };
    }, [queryClient]);

    return <LiveStatus value={status}>{children}</LiveStatus>;
}

export function useLiveStatus(): StreamStatus {
    return use(LiveStatus);
}
